import { render, staticRenderFns } from "./auto-settlement-form.vue?vue&type=template&id=f5267446&scoped=true&"
import script from "./auto-settlement-form.vue?vue&type=script&lang=js&"
export * from "./auto-settlement-form.vue?vue&type=script&lang=js&"
import style0 from "./auto-settlement-form.vue?vue&type=style&index=0&id=f5267446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5267446",
  null
  
)

export default component.exports